import { createSelector } from 'reselect';
import { selectEmail } from '../../selectors';

export const searchEmail = createSelector(selectEmail, (emailState) => emailState.search);
export const accountSearchResult = createSelector(searchEmail, (searchState) => searchState.accountSearchResult);
export const accountSelected = createSelector(searchEmail, (searchState) => searchState.accountSelected);
export const selectParameters = createSelector(searchEmail, (searchState) => searchState.parameters);
export const selectModels = createSelector(searchEmail, (searchState) => searchState.models);
